/* tslint:disable */
/* eslint-disable */
/**
 * Disponent.Online
 * Disponent.Online API
 *
 * The version of the OpenAPI document: 0.1
 * Contact: service@weberdata.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { Message } from '../models';
/**
 * AuftragexportService - axios parameter creator
 * @export
 */
export const AuftragexportServiceAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Liefert einen Count einer Auftragsliste
         * @summary Auftrag
         * @param {string} [datumVon] Datum von
         * @param {string} [datumBis] Datum bis
         * @param {number} [mandantId] Mandant
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCountZeitraumAuftragExportCsv: async (datumVon?: string, datumBis?: string, mandantId?: number, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/auftragexport/countexportcsvmtl`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (datumVon !== undefined) {
                localVarQueryParameter['datumVon'] = (datumVon as any instanceof Date) ?
                    (datumVon as any).toISOString().substr(0,10) :
                    datumVon;
            }

            if (datumBis !== undefined) {
                localVarQueryParameter['datumBis'] = (datumBis as any instanceof Date) ?
                    (datumBis as any).toISOString().substr(0,10) :
                    datumBis;
            }

            if (mandantId !== undefined) {
                localVarQueryParameter['mandantId'] = mandantId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Liefert einen csv-Export einer Auftragsliste
         * @summary Auftrag
         * @param {string} [datumVon] Datum von
         * @param {string} [datumBis] Datum bis
         * @param {number} [mandantId] Mandant
         * @param {number} [min] min
         * @param {number} [max] max
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getZeitraumAuftragExportCsv: async (datumVon?: string, datumBis?: string, mandantId?: number, min?: number, max?: number, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/auftragexport/exportcsvmtl`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (datumVon !== undefined) {
                localVarQueryParameter['datumVon'] = (datumVon as any instanceof Date) ?
                    (datumVon as any).toISOString().substr(0,10) :
                    datumVon;
            }

            if (datumBis !== undefined) {
                localVarQueryParameter['datumBis'] = (datumBis as any instanceof Date) ?
                    (datumBis as any).toISOString().substr(0,10) :
                    datumBis;
            }

            if (mandantId !== undefined) {
                localVarQueryParameter['mandantId'] = mandantId;
            }

            if (min !== undefined) {
                localVarQueryParameter['min'] = min;
            }

            if (max !== undefined) {
                localVarQueryParameter['max'] = max;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AuftragexportService - functional programming interface
 * @export
 */
export const AuftragexportServiceFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AuftragexportServiceAxiosParamCreator(configuration)
    return {
        /**
         * Liefert einen Count einer Auftragsliste
         * @summary Auftrag
         * @param {string} [datumVon] Datum von
         * @param {string} [datumBis] Datum bis
         * @param {number} [mandantId] Mandant
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCountZeitraumAuftragExportCsv(datumVon?: string, datumBis?: string, mandantId?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCountZeitraumAuftragExportCsv(datumVon, datumBis, mandantId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Liefert einen csv-Export einer Auftragsliste
         * @summary Auftrag
         * @param {string} [datumVon] Datum von
         * @param {string} [datumBis] Datum bis
         * @param {number} [mandantId] Mandant
         * @param {number} [min] min
         * @param {number} [max] max
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getZeitraumAuftragExportCsv(datumVon?: string, datumBis?: string, mandantId?: number, min?: number, max?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getZeitraumAuftragExportCsv(datumVon, datumBis, mandantId, min, max, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AuftragexportService - factory interface
 * @export
 */
export const AuftragexportServiceFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AuftragexportServiceFp(configuration)
    return {
        /**
         * Liefert einen Count einer Auftragsliste
         * @summary Auftrag
         * @param {string} [datumVon] Datum von
         * @param {string} [datumBis] Datum bis
         * @param {number} [mandantId] Mandant
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCountZeitraumAuftragExportCsv(datumVon?: string, datumBis?: string, mandantId?: number, options?: any): AxiosPromise<object> {
            return localVarFp.getCountZeitraumAuftragExportCsv(datumVon, datumBis, mandantId, options).then((request) => request(axios, basePath));
        },
        /**
         * Liefert einen csv-Export einer Auftragsliste
         * @summary Auftrag
         * @param {string} [datumVon] Datum von
         * @param {string} [datumBis] Datum bis
         * @param {number} [mandantId] Mandant
         * @param {number} [min] min
         * @param {number} [max] max
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getZeitraumAuftragExportCsv(datumVon?: string, datumBis?: string, mandantId?: number, min?: number, max?: number, options?: any): AxiosPromise<string> {
            return localVarFp.getZeitraumAuftragExportCsv(datumVon, datumBis, mandantId, min, max, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AuftragexportService - interface
 * @export
 * @interface AuftragexportService
 */
export interface AuftragexportServiceInterface {
    /**
     * Liefert einen Count einer Auftragsliste
     * @summary Auftrag
     * @param {string} [datumVon] Datum von
     * @param {string} [datumBis] Datum bis
     * @param {number} [mandantId] Mandant
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuftragexportServiceInterface
     */
    getCountZeitraumAuftragExportCsv(datumVon?: string, datumBis?: string, mandantId?: number, options?: any): AxiosPromise<object>;

    /**
     * Liefert einen csv-Export einer Auftragsliste
     * @summary Auftrag
     * @param {string} [datumVon] Datum von
     * @param {string} [datumBis] Datum bis
     * @param {number} [mandantId] Mandant
     * @param {number} [min] min
     * @param {number} [max] max
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuftragexportServiceInterface
     */
    getZeitraumAuftragExportCsv(datumVon?: string, datumBis?: string, mandantId?: number, min?: number, max?: number, options?: any): AxiosPromise<string>;

}

/**
 * AuftragexportService - object-oriented interface
 * @export
 * @class AuftragexportService
 * @extends {BaseAPI}
 */
export class AuftragexportService extends BaseAPI implements AuftragexportServiceInterface {
    /**
     * Liefert einen Count einer Auftragsliste
     * @summary Auftrag
     * @param {string} [datumVon] Datum von
     * @param {string} [datumBis] Datum bis
     * @param {number} [mandantId] Mandant
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuftragexportService
     */
    public getCountZeitraumAuftragExportCsv(datumVon?: string, datumBis?: string, mandantId?: number, options?: any) {
        return AuftragexportServiceFp(this.configuration).getCountZeitraumAuftragExportCsv(datumVon, datumBis, mandantId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Liefert einen csv-Export einer Auftragsliste
     * @summary Auftrag
     * @param {string} [datumVon] Datum von
     * @param {string} [datumBis] Datum bis
     * @param {number} [mandantId] Mandant
     * @param {number} [min] min
     * @param {number} [max] max
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuftragexportService
     */
    public getZeitraumAuftragExportCsv(datumVon?: string, datumBis?: string, mandantId?: number, min?: number, max?: number, options?: any) {
        return AuftragexportServiceFp(this.configuration).getZeitraumAuftragExportCsv(datumVon, datumBis, mandantId, min, max, options).then((request) => request(this.axios, this.basePath));
    }
}
